import { Component, inject } from '@angular/core';
import { ChildrenOutletContexts, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { routeTransitionAnimation } from './shared/animations/route-transition.animation';

import { environment } from '../environments/environment';

@Component({
  imports: [RouterModule],
  selector: 'dmcom-root',
  template: `
    <div [@routeTransition]="getRouteAnimationData()">
      <router-outlet></router-outlet>
    </div>
  `,
  animations: [routeTransitionAnimation],
})
export class AppComponent {
  private readonly translateService = inject(TranslateService);
  private readonly contexts = inject(ChildrenOutletContexts);

  constructor() {
    this.translateService.addLangs(['en']);
    this.translateService.setDefaultLang(environment.defaultLanguage);
    this.translateService.use(environment.defaultLanguage);
  }

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animationState'] as string;
  }
}
